module.exports = __webpack_public_path__ + "img/back-arrow.0f20efd4.svg";